import { Range } from 'types';

type IsValidRangeProps = {
  from: number;
  to: number;
  validRanges: Range[];
};

export const isValidRange = ({ from, to, validRanges }: IsValidRangeProps) => {
  const isValid = validRanges?.some(
    (range) => range?.from <= from && range?.to >= to && from < to
  );
  return isValid;
};
